import React, { Component, Fragment } from "react";

import utils from "../../ProducaoEP/utils/utils";

import Select from "../../ProducaoEP/Realizado/Relatorio1/Select";
import Radio from "../../ProducaoEP/Realizado/Relatorio1/Radio";

import relatorioMetasRealizadosService from "../../../services/relatorioMetasRealizadosService";
import GeneratePDF from "../GeneratePDF/IndexPDF";
import GeneratePDFOriginalRetificado from "../GeneratePDFOriginalRetificado/IndexPDF";
import utilsExport from "../../../utils/utilsExport";
import api from "../../../services/api";

export default class TabelaMetaRealizado extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas",
            dados: {},
            realizados: {},
            acumulado: {},
            mesSelecionado: "janeiro",
            isAcumulado: false,
            radioChecked: "mes",
            show: false,
            valores: {}
        }
    }

    async componentDidMount() {
        await this.getDados();
        this.checkPreRender(this.state)
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.isAcumulado !== this.state.isAcumulado || prevState.mesSelecionado !== this.state.mesSelecionado) {
            await this.getDados();
            this.checkPreRender(this.state)
        }
    }

    getDados = async () => {
        let { dados, realizados, acumulado } = await relatorioMetasRealizadosService.fetchDadosExport(this.state.mesSelecionado, this.state.isAcumulado);
        let dadosRetificados = await this.getDadosRetificada();
        this.setState({ dados, realizados, acumulado, show: true, ...dadosRetificados });
    }

    getDadosRetificada = async () => {
        let response = await api.get('/metasOriginalRetificadas');
        let dados = response.data
        return dados
    }

    selectMes = (event) => {
        this.setState({ mesSelecionado: event.target.value, show: false  })
    }

    onChange = async (event) => {
        let isAcumulado = event.target.value === "acumulado" ? true : false;
        this.setState({ isAcumulado, radioChecked: event.target.value, show: false  })
    }

    verificaSePossuiRealizado = (realizados, mesSelecionado) => {
        let realizadoMes = realizados[mesSelecionado];
        let ultimoMesApurado = mesSelecionado
        if(!realizadoMes || realizadoMes.length === 0) {
            ultimoMesApurado = this.verificaUltimoMesApurado(realizados);
            realizadoMes = realizados[ultimoMesApurado]
        }
        return [realizadoMes, ultimoMesApurado];
    }

    verificaUltimoMesApurado = (realizados) => {
        let meses = ["janeiro", "fevereiro", "marco", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
        let mesesApurados = Object.keys(realizados);

        let ultimoMesApurado = mesesApurados.reduce((acc, atual) => {
            let index = meses.indexOf(atual);
            if(index >= acc) return index;
            else return acc
        }, -1)

        return meses[ultimoMesApurado];
    }

    checkPreRender = (state) => {
        let estado = JSON.parse(JSON.stringify(state));
        let { dados, mesSelecionado, realizados, isAcumulado, radioChecked, acumulado } = estado

        let ultimoMesApurado;

        if(isAcumulado) {
            dados = JSON.parse(JSON.stringify(acumulado))
        }
        
        let isExibeFiltro = !this.props.isExibeFiltro;

        let total;
        let verificacao = this.verificaSePossuiRealizado(realizados, mesSelecionado)
        realizados = verificacao[0]
        ultimoMesApurado = verificacao[1]
        realizados = utilsExport.formataRealizadoMetas(realizados, dados[mesSelecionado])
        total = utilsExport.calculaTotal(realizados);
        this.setState({ valores: { dados, mesSelecionado, realizados, isAcumulado, radioChecked, acumulado, ultimoMesApurado, total, isExibeFiltro } })
    }

    render() {
        let { dados, mesSelecionado, realizados, isAcumulado, radioChecked, acumulado, ultimoMesApurado, total, isExibeFiltro } = this.state.valores
        let isExibe = Object.keys(this.state.valores).length > 0
        return (
            <Fragment>
                
                {
                    isExibeFiltro
                    ?
                    <div className="card">
                        <div className="card-header">
                            Opções
                        </div>
                        <div className="card-body">
                            <Select selectMes={this.selectMes} />
                            <Radio onChange={this.onChange} radioChecked={radioChecked} />
                        </div>
                    </div>
                    :
                    null
                }

                {
                    this.state.show && isExibe ? 
                        <Fragment>
                            <GeneratePDF 
                                realizados={realizados} 
                                metas={dados[mesSelecionado]} 
                                total={total} 
                                ultimoMesApurado={ultimoMesApurado} 
                                mesSelecionado={mesSelecionado} 
                                radioChecked={radioChecked} 
                                /> 
                            <GeneratePDFOriginalRetificado 
                                total={total} 
                                mesSelecionado={mesSelecionado} 
                                radioChecked={radioChecked} 
                                metaOriginalERetificada={this.state.metaOriginalERetificada}
                                metaOriginalERetificadaAcumulada={this.state.metaOriginalERetificadaAcumulada}
                                isAcumulado={isAcumulado}
                                />
                        </Fragment>
                        : 
                        <p>...carregando</p>}

            </Fragment>
        )
    }
}